import React, { useState } from 'react'
import Header from './Core/Header'
import { useNavigate } from 'react-router-dom'
import { checkByAadhaar, createHospital, loginHospital, sendOtp } from '../service/operations/api_methods.js'
import { toast } from 'sonner'
import { useDispatch } from 'react-redux'
import Login from './Pages/Login.jsx'
import { login } from '../redux/slices/authSlices.js'

const Home = () => {
  const navigate=useNavigate()
  const dispatch=useDispatch()
  const[formType,setFormType]=useState("login")

    const [aadhaar_id,setAadhaar_id]=useState('')
  const[primary_number,setPrimary_number]=useState('')
  const [otp,setOtp]=useState('')

   const[first_name,setfirst_name]=useState("")
 const[last_name,setlast_name]=useState("")
 const[email,setEmail]=useState("")
 const[gender,setGender]=useState("")
 const[profile_image,setprofile_image]=useState(null)
 const[dob,setDob]=useState("")
 const[license_number,setlicense_number]=useState("")
 const[hospital_name,sethospital_name]=useState("")
 const[address,setAddress]=useState("")



  const handleSendOtp=async(num)=>{
    console.log(num);
    
    try {
      const res=await sendOtp(num)
      console.log(res,);
      if(res.status===200){
      
        console.log("otp is: ",res.data.data.otp);
        
          setFormType('user')
            alert('Otp: ',res.data.data.otp)
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }

const handlecheckuserByAadhaar=async(e)=>{
  e.preventDefault()
  try {
    const res=await checkByAadhaar(aadhaar_id)
    console.log(res);
    
  } catch (error) {
    console.log(error);
    
        
        if(error.data.action==='LOGIN_HOSPITAL'){
        setPrimary_number(error.data.data.primary_number)
          handleSendOtp(error.data.data.primary_number)
          toast.info('Otp has been sent')
        }else if(error.data.action==="REGISTER_FIRST"){
          setFormType('register')
          toast.info('New to system, register')
        }else if(error.data.action==="REGISTER_HOSPITAL"){
          setPrimary_number(error.data.data.primary_number)
          setFormType('doc-create')
          toast.info('create hospital account')
        }
    
    
  }
}

const handleLogin=async(e)=>{
  e.preventDefault()
  try {
    const res=await loginHospital({mobile:primary_number,aadhaar_id,device_token:"fcmDeviceToken_ABC123XYZ",otp})
    console.log(res);
    if(res.status===200){
      navigate('/dashboard')
      dispatch(
      login({
        token: res.data.data.token,
        user: res.data.data,
      }))
      toast.success("Logged in successfully")
    }
    
  } catch (error) {
    console.log(error);
    
  }
}

const handleCreateHospital=async(e)=>{
  e.preventDefault()
  let data={first_name,last_name,aadhaar_id,email,gender,profile_image,primary_number,dob,license_number,hospital_name,address}
 console.log(data);

  try {
    const res=await createHospital(data)
    console.log(res);
    if(res.status===200){
      navigate("/dashboard")
      toast.info('Account created, Login now')
      
    }
   // 
  } catch (error) {
    console.log(error);
    
  }
}



  return (
    <div className='w-full bg-gray-500 h-full'>
      <Header/>
     <section style={{marginTop:"70px"}}>
      <div
      style={{
        width: "100%",              // full width of container
        height: "100vh",            // final visible height you want
        overflow: "hidden",         // hides the cropped part
        borderRadius: "15px",       // optional, for rounded corners
        position: "relative",
      }}
    >
      <video
        src="/Assets/biotech1.mp4"   // your video file
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: "100%",
          height: "auto",           // ensures scaling
          position: "absolute",
              filter: "blur(2px)",         // crop from top (adjust this value)
          objectFit: "cover",       // ensures it fills the area
        }}
      />

      <div style={{position:"absolute",zIndex:90,top:"10vh",left:"1vw",display:"flex",alignItems:"center",justifyContent:"center",gap:"30px"}}>
       <div style={{display:"flex",flexDirection:"column",width:"50%"}}> 
        <p style={{ color: "#fff", // white text
          fontSize: "58px",
          fontWeight: "bold",
          textAlign: "center",
          width:"100%",
          textShadow: `
            0 0 3px #000000ff,
            0 0 6px rgba(158, 158, 158, 1),
            0 0 9px rgba(221, 221, 221, 1)
          `,}}>
          Connecting Care, Expertise, and Patients Seamlessly</p>
        <p style={{fontSize:"28px",fontWeight:"700",color:"white",width:"100%",textAlign:"center"}}>Empowering hospitals, doctors, and diagnostic centers with a unified platform for smarter healthcare collaboration.</p>
      </div>
      <div style={{width:"50%",height:"70vh",margin:"20px",
           backdropFilter: "blur(10px)",       // blur effect
    backgroundColor: "rgba(255, 255, 255, 0.2)", // transparent background (20% white)
    WebkitBackdropFilter: "blur(20px)",
    borderRadius:"15px",  boxShadow: "0 0 15px 3px rgba(0,0,0,0.25)",
    display:"flex",flexDirection:"column",alignItems:"center"
      }}>
        <p style={{fontSize:"30px",fontWeight:"700",textAlign:"center",color:"white",
          textShadow: `
            0 0 3px #000000ff,
            0 0 6px rgba(158, 158, 158, 1),
            0 0 9px rgba(221, 221, 221, 1)
          `,marginTop:"20px"
        }}>
          {formType==="login"?"Login to Account"
          :formType==="user"?"Create new Account"
        :"Register your Hospital"}
          </p>


      {formType==="login"? 
       <form style={{margin:"30px",padding:"20px",borderRadius:"10px",backgroundColor:"#b1ddfaff",
           display:"flex",flexDirection:"column",alignItems:"center"
        }}>
          <p style={{color:'gray',fontWeight:"bold"}}>Aadhaar No</p>
          <input style={{
            width:'100%',
            padding:"8px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={aadhaar_id}
          onChange={(e)=>setAadhaar_id(e.target.value)}
          placeholder='1234 1234 1234 1234'/>
          <button onClick={handlecheckuserByAadhaar}
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX"
          }}>Login</button>
          
          <p style={{fontSize:"14px",color:"gray"}}>New to this Platform? {" "}
            <span onClick={()=>setFormType("user")}
            style={{color:"black",cursor:"pointer"}}>Register</span> </p>
        </form>
      :formType==="user"? // otp modal , when user is present
       <form style={{margin:"30px",padding:"20px",borderRadius:"10px",backgroundColor:"#b1ddfaff",
           display:"flex",flexDirection:"column",alignItems:"center"
        }}>
          <p style={{color:'gray',fontWeight:"bold"}}>Otp</p>
          <input style={{
            width:'100%',
            padding:"8px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={otp}
          onChange={(e)=>setOtp(e.target.value)}
          placeholder='Enter otp'
          />

          <button onClick={handleLogin}
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX"
          }}>Verify</button>
          
         
        </form> 
        : //when user is not present
        formType==="doc-create"? // otp modal , when user is present
       <form style={{margin:"10px",padding:"20px",borderRadius:"10px",backgroundColor:"#b1ddfaff",
           display:"flex",flexDirection:"column",alignItems:"center",gap:"6px"
        }}>
        
     
          <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={license_number}
          onChange={(e)=>setlicense_number(e.target.value)}
          placeholder='Enter License Number'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={hospital_name}
          onChange={(e)=>sethospital_name(e.target.value)}
          placeholder='Enter Hospital Name'/>
        </div>
         
          <div style={{display:"flex",gap:"10px"}}> 
        
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={address}
          onChange={(e)=>setAddress(e.target.value)}
          placeholder='Enter Address'/>
        </div>

        <input 
        onChange={(e)=>setprofile_image(e.target.files[0])}
        type='file'/>
         
          
          
          
          <button onClick={handleCreateHospital}
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX"
          }}>Register</button>
          
          <p style={{fontSize:"14px",color:"gray"}}>Have account? {" "}
            <span onClick={()=>setFormType("login")}
            style={{color:"black",cursor:"pointer"}}>Login</span> </p>
        </form>  
        :
        <form style={{margin:"10px",padding:"20px",borderRadius:"10px",backgroundColor:"#b1ddfaff",
           display:"flex",flexDirection:"column",alignItems:"center",gap:"6px"
        }}>
        
         <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={first_name}
          onChange={(e)=>setfirst_name(e.target.value)}
          placeholder='Enter First name'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={last_name}
          onChange={(e)=>setlast_name(e.target.value)}
          placeholder='Enter Last name'/>
        </div>
          <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
          placeholder='Enter Email'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={primary_number}
          onChange={(e)=>setPrimary_number(e.target.value)}
          placeholder='Enter Primary Number'/>
        </div>
          <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={license_number}
          onChange={(e)=>setlicense_number(e.target.value)}
          placeholder='Enter License Number'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={hospital_name}
          onChange={(e)=>sethospital_name(e.target.value)}
          placeholder='Enter Hospital Name'/>
        </div>
          <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={aadhaar_id}
          onChange={(e)=>setAadhaar_id(e.target.value)}
          placeholder='Enter Aadhaar Number'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={gender}
          onChange={(e)=>setGender(e.target.value)}
          placeholder='Enter gender'/>
        </div>
          <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          type='date'
          value={dob}
          onChange={(e)=>setDob(e.target.value)}
          placeholder='Enter date of birth'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={address}
          onChange={(e)=>setAddress(e.target.value)}
          placeholder='Enter Address'/>
        </div>

        <input 
        onChange={(e)=>setprofile_image(e.target.files[0])}
        type='file'/>
         
          
          
          
          <button onClick={handleCreateHospital}
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX"
          }}>Register</button>
          
          <p style={{fontSize:"14px",color:"gray"}}>Have account? {" "}
            <span onClick={()=>setFormType("login")}
            style={{color:"black",cursor:"pointer"}}>Login</span> </p>
        </form> 
      }

      </div>
      </div>
    </div>

     </section>

      
    </div>
  )
}

export default Home
